import React, { memo } from 'react';

import RichText from 'components/RichText/RichText';
import Text from 'components/Text/Text';
import { useCopyStore } from 'store';
import { redirectToPage } from 'utils';
import { appState } from 'utils/appState';

import * as S from './Related.styles';

export interface RelatedProps {
  label: string;
  articles: {
    __typename: 'InsightsArticles' | 'CaseStudyPages' | 'NewsArticles';
    id: number;
    name: string;
    slug: string;
    order: number;
  }[];
}

const Related: React.FunctionComponent<RelatedProps> = ({
  label,
  articles,
  ...rest
}) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);

  const hoverTextColor =
    globalSettings?.buttonsHoverColor ||
    globalSettings?.buttonsHoverDefaultColors;

  return (
    <S.Wrapper {...rest}>
      {label && (
        <RichText as="h4" size="heading4" richText={label} defaultFormatting />
      )}

      <S.Articles
        onClick={(e: any) => {
          appState.analytics.trackArticleClick(e.target.innerText);
        }}
        hoverTextColor={hoverTextColor}
      >
        {articles
          ?.sort((a, b) => a.order - b.order)
          .map(({ __typename, id, name, slug }) => (
            <S.Article key={id}>
              <a
                href={redirectToPage(__typename, slug)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Text as="span" text={name} size="heading5" />
              </a>
            </S.Article>
          ))}
      </S.Articles>
    </S.Wrapper>
  );
};

export default memo(Related);
